import React from 'react';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Research from './components/Research/Research';
import Teaching from './components/Teaching/Teaching';
import TexGenia from './components/TexGenia/TexGenia';
import Projects from './components/Projects/Projects';
import Publications from './components/Publications/Publications';
import Contact from './components/Contact/Contact';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Research />
      <Teaching />
      <TexGenia />
      <Projects />
      <Publications />
      <Contact />
    </div>
  );
}

export default App;
